
<customer-authentication
  @onContinueToFeatureConfig="continueToFeatureConfig"
>
</customer-authentication>
